/** Disallow whitespace-only input; shared by text and textarea fields */
export default function sanitizeWhitespace(onChange: (...event: unknown[]) => void) {
  return (inputValue: string) => {
    if (inputValue.trim() === "" && inputValue !== "") {
      onChange("");
    } else {
      onChange(inputValue);
    }
  };
}
